import { useContext, useEffect, useState } from "react";
import {
  CurrentAdministratorDocument,
  CurrentUserDocument,
  useCurrentAdministratorQuery,
  useCurrentUserQuery,
} from "./index.generated";
import { GraphqlClientContext } from "~/main";

export const useAuth = () => {
  const { graphqlClient } = useContext(GraphqlClientContext);

  const [isAdmin, setIsAdmin] = useState(true);
  const [isUser, setIsUser] = useState(true);
  const [currentUserId, setCurrentUserId] = useState<string | undefined>(
    undefined
  );
  const [currentAdminId, setCurrentAdminId] = useState<string | undefined>(
    undefined
  );

  const [currentUserRes, currentUser] = useCurrentUserQuery();
  const [currentAdminRes, currentAdmin] = useCurrentAdministratorQuery();

  useEffect(() => {
    let jwt_token = localStorage.getItem("jwt_token");
    if (jwt_token) {
      currentAdmin();
      currentUser();
    }
  }, []);

  useEffect(() => {
    if (currentUserRes.data?.currentUser) {
      setIsUser(true);
      setCurrentUserId(currentUserRes.data.currentUser.id);
    } else {
      setIsUser(false);
      setCurrentUserId(undefined);
    }
  }, [currentUserRes]);

  useEffect(() => {
    if (currentAdminRes.data?.currentAdministrator) {
      setIsAdmin(true);
      setCurrentAdminId(currentAdminRes.data.currentAdministrator.id);
    } else {
      setIsAdmin(false);
      setCurrentAdminId(undefined);
    }
  }, [currentAdminRes]);

  const refetchUserAuth = () => {
    return new Promise((resolve, reject) => {
      graphqlClient
        .query(CurrentUserDocument, {}, { requestPolicy: "network-only" })
        .toPromise()
        .then((res: any) => {
          if (res.data?.currentUser) {
            setIsUser(true);
          }
          return resolve("success");
        })
        .catch((e: any) => {
          return reject("error");
        });
    });
  };

  const refetchAdminAuth = () => {
    return new Promise((resolve, reject) => {
      graphqlClient
        .query(
          CurrentAdministratorDocument,
          {},
          { requestPolicy: "network-only" }
        )
        .toPromise()
        .then((res: any) => {
          if (res.data?.currentAdministrator) {
            setIsAdmin(true);
          }
          return resolve("success");
        })
        .catch((e: any) => {
          return reject("error");
        });
    });
  };

  return {
    isUser,
    isAdmin,
    currentAdminId,
    currentUserId,
    refetchUserAuth,
    refetchAdminAuth,
  };
};
